import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-counsilling',
  templateUrl: './counsilling.component.html',
  styleUrls: ['./counsilling.component.css']
})
export class CounsillingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
